import apolloClient from 'utils/apolloClient';
import PaginatedBoxes from 'assets/graphql/queries/PaginatedBoxes.graphql';
/**
 * @param page_config {object} contains page_number and per_page
 * @param order_by {string}
 * @param filters {object} contains province_id, order_by, search_term, at_home, landing slug
 * @return data from paginated_boxes query
 */

const getPaginatedBoxes = async (page_config, filters, order_by) => {
  let { per_page = null, page_number } = page_config;

  try {
    const { data } = await apolloClient.query({
      query: PaginatedBoxes,
      fetchPolicy: 'network-only',
      variables: {
        page_number: page_number,
        per_page: per_page,
        order_by: order_by,
        filters,
      },
    });

    return { response: data.paginated_boxes, others: [] };
  } catch (e) {
    throw new Error(`error fetching paginated boxes`, e);
  }
};

export { getPaginatedBoxes };
